'use client'

import { Box, Card, CardContent, Grid, Stack, Typography } from '@mui/material'
import { Section, TextBlock, toDollars } from '@wolfdanepug/common-react'

export default function PlanConfirmation({ subscription, quote }: any) {
	const data = quote?.data?.[0]
	const meta = quote?.meta?.[data.plan]
	const currentPlan =
		subscription?.plans && data?.plan
			? subscription?.plans?.find((p: any) => p.id === data.plan)
			: null

	return (
		<>
			<Section header="Current Plan" headerVariant="h5">
				<Card>
					<CardContent>
						<Grid container spacing={2}>
							<Grid item xs={8}>
								{currentPlan?.products.map((product: any) => (
									<Stack key={`current-product-${product?.id}`}>
										<Typography variant="h6">{product?.name}</Typography>
										<Typography variant="caption">Portion Size: {currentPlan?.meal} oz.</Typography>
										<Typography variant="caption">
											{14 / currentPlan?.products.length} servings.
										</Typography>
									</Stack>
								))}
							</Grid>
							<Grid item xs={4}>
								<Box>
									<TextBlock
										title="Price"
										text={`$${toDollars(subscription?.price ?? 0)}/ ${subscription?.term || 1} weeks`}
									/>
								</Box>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Section>
			<Section header="New Plan" headerVariant="h5">
				<Card>
					<CardContent>
						<Grid container spacing={2}>
							<Grid item xs={8}>
								<Stack gap={3}>
									{meta?.products?.map((product: any) => (
										<Stack key={`new-plan-${product.product}`}>
											<Typography variant="h6">{product.name}</Typography>
											<Typography variant="caption">Portion Size: {product.weight} oz.</Typography>
											<Typography variant="caption">
												{14 / meta.products.length} servings.
											</Typography>
										</Stack>
									))}
								</Stack>
							</Grid>
							<Grid item xs={4}>
								<Box>
									<TextBlock
										title="New Price"
										text={`$${toDollars(meta?.price ?? 0)}/ ${subscription?.term || 1} weeks`}
									/>
								</Box>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Section>
		</>
	)
}
